'use strict';

var fragt = fragt || {};
var novicell = novicell || {};

fragt.tracktrace = fragt.tracktrace || new function () {

    this.init = function () {
        if (document.getElementById("track-trace-id") != null) {
            var form = document.getElementById('track-trace-form');

            form.onsubmit = function (e) {
                e.preventDefault();
                var url = document.getElementById("track-trace-url").value;
                var trackid = document.getElementById("track-trace-id").value;
                document.location = url + trackid;
            };
        }
    };
}();
